var map = {
	"./AboutUs/appletImg.png": 1885,
	"./AboutUs/bannerAboutUs.png": 5999,
	"./AboutUs/officialAccountImg.png": 836,
	"./AboutUs/ourMissionImg.png": 6068,
	"./AboutUs/ourVisionImg.png": 8387,
	"./CoreCompetence/CoreCompetenceMapImg.png": 3758,
	"./CoreCompetence/ProfessionalTraining.png": 4572,
	"./CoreCompetence/advancedTechnique.png": 8282,
	"./CoreCompetence/bannerCoreCompetence.png": 8123,
	"./CoreCompetence/bannerCoreCompetence_2.png": 1711,
	"./CoreCompetence/bannerCoreCompetence_3.png": 4098,
	"./CoreCompetence/custodyBg.png": 1051,
	"./CoreCompetence/goodService.png": 6658,
	"./DisabilityImg.png": 2655,
	"./EnvironmentalTransformationImg.png": 2686,
	"./HealthGuardianBg.png": 2073,
	"./IntelligentPensionImg.png": 2029,
	"./PensionInstitutionsImg.png": 5311,
	"./ServiceCapability/bannerServiceCapability.png": 9484,
	"./ServiceCapability/bannerServiceCapability_2.png": 3744,
	"./ServiceCapability/bannerServiceCapability_3.png": 9879,
	"./ServiceCapability/emergencyResponseImg.png": 83,
	"./ServiceCapability/emergencyResponseImg_1.png": 1646,
	"./ServiceCapability/img_1.png": 745,
	"./ServiceCapability/img_1L.png": 9616,
	"./ServiceCapability/img_2.png": 4176,
	"./ServiceCapability/img_2L.png": 7281,
	"./ServiceCapability/img_3.png": 966,
	"./ServiceCapability/img_3L.png": 6867,
	"./ServiceCapability/img_4.png": 9401,
	"./ServiceCapability/img_4L.png": 4665,
	"./ServiceCapability/img_5.png": 9255,
	"./ServiceCapability/img_5L.png": 8615,
	"./ServiceCapability/left.png": 7937,
	"./ServiceCapability/pensionEquipmentImg.png": 3132,
	"./ServiceCapability/pensionPlatformImg.png": 8165,
	"./ServiceCapability/radarImg.png": 9492,
	"./ServiceCapability/right.png": 962,
	"./ServiceCapability/serviceContentImg.png": 4745,
	"./ServiceCapability/serviceContentImg_2.png": 1280,
	"./ServiceCapability/serviceContentImg_3.png": 6685,
	"./ServiceCapability/serviceContentImg_4.png": 9584,
	"./ServiceCapability/sosImg.png": 1062,
	"./Solution/bannerSolution.png": 6979,
	"./Solution/bannerSolution_2.png": 3613,
	"./Solution/bannerSolution_3.png": 4728,
	"./Solution/flagIcon.png": 2748,
	"./Telephone.png": 6625,
	"./VeteranHealthImg.png": 488,
	"./applicableScenarioBg.png": 3293,
	"./applicableScenarioItebg.png": 3553,
	"./benefitOneImg.png": 4677,
	"./benefitThImg.png": 7187,
	"./benefitTwoImg.png": 1931,
	"./cardiovascularImg.png": 4724,
	"./digitizationChart.png": 4521,
	"./emergencyImg.png": 1707,
	"./employeeWelfareImg.png": 917,
	"./environmentalTransformation.png": 7176,
	"./fallImg.png": 2132,
	"./healthCareBg.png": 670,
	"./healthMonitoring.png": 8984,
	"./healthRisksbg.png": 1347,
	"./home/downloadApk.png": 5666,
	"./home/ykyh_logo.png": 7411,
	"./homebannerOne.png": 4554,
	"./homebannerOne_2.png": 9757,
	"./homebannerOne_3.png": 4393,
	"./homehealthmonitoringImg.png": 2547,
	"./innutritionImg.png": 4941,
	"./logo.png": 6949,
	"./logoIcon.png": 1444,
	"./logotransparent.png": 3972,
	"./nursingInstitutionsImg.png": 8236,
	"./riskButtonbg.png": 5532,
	"./securityImg.png": 6649,
	"./valueAddedImg.png": 8292,
	"./videobg.png": 5540,
	"./weakImg.png": 5932
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;